const menu = [
    {
        to: "#home",
        icon: 'icon la la-home',
        title: 'Home'
    },
    {
        to: "#about",
        icon: 'icon la la-user',
        title: 'about'
    },
    {
        to: "#resume",
        icon: 'icon la la-gear',
        title: 'resume'
    },
    {
        to: "#portfolio",
        icon: 'icon la la-eye',
        title: 'portfolio'
    },
    {
        to: "#blog",
        icon: 'icon la la-newspaper-o',
        title: 'blog'
    },
    {
        to: "#contact",
        icon: 'icon la la-envelope',
        title: 'contact'
    },  
];
export default menu;
